// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1InW8","checkboxCol":"Table_checkboxCol__1VHlO","emailCol":"Table_emailCol__3xpz2","actionCol":"Table_actionCol__1D3vh"};